<svg
  width="100%"
  height="100%"
  viewbox="0 0 100 50"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    *ngFor="let datum of processedData; trackBy: null | trackByKey"
    [attr.x]="datum.xStartPercent"
    [attr.y]="datum.yStartPercent"
    [attr.width]="datum.widthPercent"
    [attr.height]="datum.heightPercent"
    style="fill: #FF6358"
  />
</svg>
